import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-orange bg-brand-yellow" data-id="element-112" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-113" data-mp="id8dctzdn4ve">
        <p className="inline-block rounded-md bg-brand-navy px-2 py-0.5 font-sub text-sm font-bold leading-tight text-brand-yellow" data-id="element-114" data-mp="icym732liro4">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.75rem] leading-[1.05] text-brand-navy sm:text-5xl" data-id="element-115" data-mp="repodxxxggd8">
          Comiencen hoy a crear, descubrir y aprender a su propio ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-brand-navy bg-white text-brand-navy" data-id="element-116" data-mp="2y44b74ll4hj6">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-brand-cream" data-id="element-117" data-mp="12ojzyn1w6mr1">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-118" data-mp="sxfldog4p3wq" />
          </a>
          <div className="p-3" data-id="element-119" data-mp="1lme4ans2sa33">
            <p className="font-sans text-sm font-extrabold uppercase leading-tight text-brand-blue" data-id="element-120" data-mp="1lmmjimbo7rhg">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-3xl leading-none" data-id="element-121" data-mp="1gl6wiopxnawf">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-brand-muted sm:text-sm" data-id="element-122" data-mp="17mlj17zbim2i">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-2" data-id="element-123" data-mp="172hvg5nkfbv">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-brand-orange px-3 py-0.5 font-sans text-xs font-extrabold uppercase text-brand-navy" data-id="element-124" data-mp="3scax3is763u5">
              🔥 Oferta especial
            </p>
            <p className="mt-1 font-display text-6xl leading-none text-brand-green sm:text-7xl" data-id="element-125" data-mp="2ngbgd5ixuhz">
              <span className="text-3xl text-brand-navy sm:text-4xl" data-id="element-126" data-mp="3ktl24wa4ubed">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-brand-muted" data-id="element-127" data-mp="3otv9oddkp9vc">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-128" data-mp="3b1ouati8v6wy">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-brand-muted" data-id="element-129" data-mp="316n8a6j9mkyl">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}